import React from "react";

// Уул + нуурын давалгаа — логотой ижил санаатай жижиг тэмдэг (хэсгийн гарчгийн дээрх чимэглэл)
export const LakeMark = ({ className = "" }) => (
  <svg viewBox="0 0 24 16" className={className} aria-hidden="true">
    <path d="M3 9.5 9 2l3.5 4.5L15.5 3.5 21 9.5z" fill="currentColor" />
    <path
      d="M1.5 13.5q2.6-2.4 5.25 0t5.25 0 5.25 0 5.25 0"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

export const Eyebrow = ({ children, className = "" }) => (
  <span className={`inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-primary ${className}`}>
    <LakeMark className="w-5 h-[14px]" /> {children}
  </span>
);

// Нүүр хуудасны хэсгүүдийн голлуулсан гарчиг
const SectionHeading = ({ eyebrow, title, subtitle, className = "" }) => (
  <div className={`max-w-2xl mx-auto text-center mb-12 ${className}`}>
    <Eyebrow>{eyebrow}</Eyebrow>
    <h2 className="mt-3 font-display text-3xl md:text-4xl font-extrabold text-foreground">{title}</h2>
    {subtitle && <p className="mt-3 text-lg text-muted-foreground">{subtitle}</p>}
  </div>
);

export default SectionHeading;
